export enum FONTS_WEIGHTS {
  THIN = 100,
  EXTRA_LIGHT = 200,
  LIGHT = 300,
  REGULAR = 400,
  MEDIUM = 500,
  SEMIBOLD = 600,
  BOLD = 700,
  EXTRA_BOLD = 800,
  BLACK = 900
}

export enum FONTS_STYLES {
  NORMAL = 'Normal',
  ITALIC = 'Italic'
}

export enum FONTS_FAMILIES {
  RED_HAT_DISPLAY = 'Red Hat Display',
  QUICKSAND = 'Quicksand'
}


export const fonts = {
  RHDRegularNormal: {
    fontFamily: [FONTS_FAMILIES.RED_HAT_DISPLAY, 'Roboto', 'Arial', '-apple-system'].join(','),
    fontWeight: FONTS_WEIGHTS.REGULAR,
    style: FONTS_STYLES.NORMAL
  },
  RHDMediumNormal: {
    fontFamily: [FONTS_FAMILIES.RED_HAT_DISPLAY, 'Roboto', 'Arial', '-apple-system'].join(','),
    fontWeight: FONTS_WEIGHTS.MEDIUM,
    style: FONTS_STYLES.NORMAL
  },
  RHDMediumSemiBold: {
    fontFamily: [FONTS_FAMILIES.RED_HAT_DISPLAY, 'Roboto', 'Arial', '-apple-system'].join(','),
    fontWeight: FONTS_WEIGHTS.SEMIBOLD,
    style: FONTS_STYLES.NORMAL
  },
  RHDRegulartItalic: {
    fontFamily: [FONTS_FAMILIES.RED_HAT_DISPLAY, 'Roboto', 'Arial', '-apple-system'].join(','),
    fontWeight: FONTS_WEIGHTS.REGULAR,
    style: FONTS_STYLES.ITALIC
  },
  RHDBoldNormal: {
    fontFamily: [FONTS_FAMILIES.RED_HAT_DISPLAY, 'Roboto', 'Arial', '-apple-system'].join(','),
    fontWeight: FONTS_WEIGHTS.BOLD,
    style: FONTS_STYLES.NORMAL
  },
  QSDBoldNormal: {
    fontFamily: [FONTS_FAMILIES.QUICKSAND, 'sans-serif'].join(','),
    fontWeight: FONTS_WEIGHTS.BOLD,
    style: FONTS_STYLES.NORMAL
  },
};
